// extracted by mini-css-extract-plugin
module.exports = {"example":"example-92e1a868","group-intro":"group-intro-f466de08","groupIntro":"group-intro-f466de08"};